module.exports = __webpack_public_path__ + "static/media/background.c7040c44.png";